__turbopack_context__.v({
  "avatar": "Avatar-module-scss-module__J_snjW__avatar",
});
